var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(option){return _c('el-option',{key:option.value,attrs:{"label":_vm.$t(option.label),"value":option.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }